<template>
  <div dir="rtl" class="modal fade" id="user-verification-modal" tabindex="-1">
    <div class="modal-dialog modal-md modal-dialog-centered" style="max-width: 500px">
      <div class="modal-content p-3">
        <div class="modal-header border-0 pb-0">
          <h5 class="modal-title">
            {{ step === 1 ? "التحقق من رقم الهاتف" : "تأكيد الرمز" }}
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>

        <div class="modal-body">
          <!-- الصورة -->
          <div class="text-center mb-3">
            <img src="assets/img/unverified-user.png" style="width: 165px" />
          </div>

          <!-- رسالة النجاح -->
          <p v-if="successMessage" class="text-center text-success fw-bold">
            {{ successMessage }}
          </p>

          <p v-if="step === 1" class="text-center bg-light p-2 rounded">
            أدخل رقم الهاتف لإرسال رمز التحقق
          </p>

          <p v-else class="text-center bg-light p-2 rounded">أدخل رمز التحقق الذي وصلك</p>

          <!-- خطوة إدخال رقم الهاتف -->
          <div v-if="step === 1">
            <div class="form-group mb-3">
              <label>رقم الهاتف</label>
              <input id="verifyPhone" type="tel" class="form-control" dir="ltr" />
            </div>

            <!-- اختيار وسيلة الإرسال -->

            <small v-if="errorMessage" class="text-danger d-block mb-2">{{
              errorMessage
            }}</small>

            <button
              class="btn btn-success w-100"
              :disabled="isLoading"
              @click="sendPhone"
            >
              {{ isLoading ? "جاري الإرسال..." : "إرسال الرمز" }}
            </button>
          </div>

          <!-- خطوة إدخال OTP -->
          <div v-else>
            <div class="form-group mb-3">
              <label>رمز التحقق (OTP)</label>
              <input
                v-model="otp"
                type="text"
                class="form-control"
                placeholder="أدخل الرمز"
              />
            </div>

            <small v-if="errorMessage" class="text-danger d-block mb-2">{{
              errorMessage
            }}</small>

            <div class="d-flex gap-2">
              <button
                class="btn btn-secondary w-50"
                :disabled="isLoading"
                @click="goBack"
              >
                رجوع
              </button>
              <button
                class="btn btn-success w-50"
                :disabled="isLoading"
                @click="verifyOtp"
              >
                {{ isLoading ? "جاري التحقق..." : "تأكيد" }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { apiUrl } from "@/utils/api";
var itiVerify;

export default {
  data() {
    return {
      step: 1,
      otp: "",
      isLoading: false,
      errorMessage: "",
      successMessage: "",
      selectedMethod: "sms", // default
      token: localStorage.getItem("access_token"),
    };
  },
  mounted() {
    const modal = document.getElementById("user-verification-modal");
    const phone = document.getElementById("verifyPhone");

    modal.addEventListener("shown.bs.modal", () => {
      itiVerify = intlTelInput(phone, {
        utilsScript: "assets/js/utils.js",
        initialCountry: "ly",
        separateDialCode: true,
        excludeCountries: ["il"],
      });
    });
  },
  methods: {
    goBack() {
      this.errorMessage = "";
      this.successMessage = "";
      this.otp = "";
      this.step = 1;
      this.selectedMethod = "sms";
      this.$nextTick(() => {
        const phone = document.getElementById("verifyPhone");
        itiVerify = intlTelInput(phone, {
          utilsScript: "assets/js/utils.js",
          initialCountry: "ly",
          separateDialCode: true,
          excludeCountries: ["il"],
        });
      });
    },

    async sendPhone() {
      this.errorMessage = "";
      this.successMessage = "";
      let Newtoken = localStorage.getItem("access_token");
      //alert(Newtoken);
      try {
        this.isLoading = true;
        const phoneNumber = itiVerify.getNumber();

        const payload = {
          phone: phoneNumber,
          country_code: "+" + itiVerify.getSelectedCountryData().dialCode,
        };

        const res = await fetch(`${apiUrl}/user_verification/send-otp`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${Newtoken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        if (!res.ok) {
          const errData = await res.json().catch(() => ({}));
          throw new Error(errData.message || "حدث خطأ أثناء الإرسال");
        }

        this.successMessage = "تم إرسال الرمز إلى رقمك";
        this.step = 2;
      } catch (err) {
        this.errorMessage = err.message || "حدث خطأ أثناء الإرسال";
      } finally {
        this.isLoading = false;
      }
    },

    async verifyOtp() {
      let Newtoken = localStorage.getItem("access_token");

      this.errorMessage = "";
      if (!this.otp) {
        this.errorMessage = "يرجى إدخال رمز التحقق";
        return;
      }
      this.isLoading = true;

      try {
        const res = await fetch(`${apiUrl}/user_verification/verify-mobile`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${Newtoken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ otp: this.otp }),
        });
        if (!res.ok) {
          const errData = await res.json().catch(() => ({}));
          throw new Error(errData.message || "حدث خطأ أثناء التحقق");
        }
        Swal.fire("تم التحقق", "تم تأكيد رقم هاتفك بنجاح", "success");
        this.goBack();
      } catch (err) {
        this.errorMessage = err.message || "حدث خطأ أثناء التحقق";
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.modal-content {
  border-radius: 12px;
}
.form-group label {
  font-weight: 600;
  margin-bottom: 8px;
}
.btn {
  padding: 10px;
  font-weight: bold;
}
</style>
